import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
    selector: 'ws-ace-tab',
    templateUrl: './tab.component.html',
    styleUrls: ['../Tabs/tabs.component.scss', './tab.component.scss'],
    standalone: false
})
export class AceTabComponent {
    @Input() identifier: string;
    @Input() label: string;
    @Input() icon: string;

    @HostBinding('attr.vertical')
    @Input() vertical: boolean;
    @HostBinding('attr.dropdownView')
    @Input() dropdownView: boolean;
    @HostBinding('attr.active')
    @Input() active: boolean;
    @HostBinding('attr.disabled')
    @Input() disabled: boolean;

    @Output() tabActivated?: EventEmitter<string> = new EventEmitter<string>();

}
